import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const visiblePages = 3;
  const half = Math.floor(visiblePages / 2);

  const getPageNumbers = () => {
    let start = Math.max(currentPage - half, 1);
    let end = start + visiblePages - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - visiblePages + 1, 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="pagination-controls">
      <button onClick={() => onPageChange(1)} disabled={currentPage === 1}>
        «
      </button>
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        ‹
      </button>

      {getPageNumbers().map((page) => (
        <button
          key={page}
          className={page === currentPage ? 'active' : ''}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}

      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        ›
      </button>
      <button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
        »
      </button>
    </div>
  );
};

export default Pagination;
